'use client'
import { Intro } from '@/components/parts/intro/Intro'
import { FeeStructure } from '../../parts/flow/FeeStructure'
import { AnchorRequest } from '../../parts/AnchorRequest'
import { Flow } from '../../parts/flow/Flow'
import { DocumentForm } from '../../forms/DocumentForm'
import { Contact } from '@/components/parts/contact'
import { Department } from '@/types/newt/department'
import { Opportunity } from '@/types/newt/opportunity'

type FlowPageProps = {
  departments: Department[]
  opportunities: Opportunity[]
  currentUrl: string
}

const FlowContent: React.FC<FlowPageProps> = ({
  departments,
  opportunities,
  currentUrl
}) => {
  return (
    <>
      <Intro
        title="料金・ご導入の流れ"
        lead="料金体系・導入までの流れの情報をまとめています<br>弊社担当から詳細なご説明させていただくことも可能ですので、<br>お気軽にお問い合わせください"
      />
      <FeeStructure />
      <AnchorRequest position="request" />
      <Flow />
      <DocumentForm
        bg="bg-formbg"
        departments={departments}
        opportunities={opportunities}
      />
      <Contact bg="bg-lawguebase" />
    </>
  )
}

export default FlowContent
